module.exports = __webpack_public_path__ + "static/send_message-016ee5e32507e5e5d08648999d03461b.webp";